export default function lessThanDirective(app) {
	app.directive('lessThan', function() {
		return {
			restrict: 'A',
			require: '^form',
			link: function($scope, element, attrs, ctrl) {
				ctrl[attrs.name].$validators['maxNum'] = function (ngModelValue) {
					if (!attrs.lessThan || attrs.lessThan === null || attrs.lessThan === undefined || isNaN(attrs.lessThan)) {
						return true;
					}
					if (ngModelValue === undefined || ngModelValue === null || ngModelValue === "") {
						return true;
					}
					return !isNaN(ngModelValue) ? (+ngModelValue < +attrs.lessThan) : false;
				};
			}
		};
	});
}
